import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTSVG } from "../../../_metronic/helpers";
import { accountApprovalInitialsForAdd, accountApprovalInitialsForUpdate } from "./interfaces/AccountApprovalClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountApprovalTypeAsync, updateAccountApprovalTypeAsync, resetSelectedRecordObjectInState, DeleteSelectedAccountApprovalPathAsync, getAccountApprovalByAccountApprovalTypeIdAsync } from "./AccountApprovalSlice";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { Formik, useFormik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import CanvasLoader from "../../../common/CanvasLoader";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";


export const AccountApprovalForm = (props: any) => {
    const { t, IsEdit, IsDelete } = props;

    const [currentFieldsData, setCurrentFieldsData] = useState<any>(accountApprovalInitialsForAdd)
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [selectedSystemApproverTypeOptionDropDown, setSelectedSystemApproverTypeOptionDropDown] = useState([]);
    const [systemApproverTypesArray, setSystemApproverTypesArray] = useState<any | ''>([]);
    const { maxMenuHeight, manageTerminologyList } = useAppSelector(state => state.globalState);
    const [selectedExternalUserOptionDropDown, setSelectedExternalUserOptionDropDown] = useState([]);
    const [externalUsersArray, setExternalUsersArray] = useState<any | ''>([]);

    const [selectedEmployeeOptionDropDown, setSelectedEmployeeOptionDropDown] = useState([]);
    const [employeesArray, setEmployeesArray] = useState<any | ''>([]);

    const [selectedSequenceOptionDropDown, setSelectedSequenceOptionDropDown] = useState([]);
    const [sequenceArray, setSequenceArray] = useState<any | ''>([]);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);



    const { selectedRecord, isLoading } = useAppSelector((state) => state.accountApproval);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    let AccountApprovalTypeId: number = 0;


 

    const formik = useFormik({
        initialValues: currentFieldsData, // Pass your initialValues object
        enableReinitialize: true,
        validationSchema: yup.object().shape({
            ApprovalTypeName: yup
                .string()
                .label('ApprovalTypeName')
                .trim()
                .required(t('Approval type name is required')),
            // Define validation rules for other fields
        }),
        onSubmit: (values, action) => {
            handleSubmit(values);
            action.resetForm();
        },
    });


    const getSystemApproverTypesAsync = async () => {
        const response = await fetchAPI("api/V2/Approvals/SystemApproverTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json1 = await response.json();
        const json = json1.Data;

        json.map((item: any) => {
            item.value = item.SystemApproverTypeId;
            item.label = item.SystemApproverType;
            delete item.SystemApproverTypeId;
            delete item.SystemApproverType;
        });

        setSystemApproverTypesArray(json);

    }

    // const getExternalUsersAsync = async () => {
    //     const response = await fetchAPI("api/V2/ExternalUsers", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    //     const json1 = await response.json();
    //     const json = json1.Data;

    //     json.map((item: any) => {
    //         item.value = item.AccountEmployeeId;
    //         item.label = item.EmployeeName;
    //         delete item.AccountEmployeeId;
    //         delete item.EmployeeName;
    //     });



    //     setExternalUsersArray(json);
    // }
    const getExternalUsersAsync = async () => {
        try {
            const response = await fetchAPI("api/V2/ExternalUsers", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json1 = await response.json();
            const json = json1.Data;

            if (json && Array.isArray(json)) {
                json.map((item: any) => {
                    item.value = item.AccountEmployeeId;
                    item.label = item.EmployeeName;
                    delete item.AccountEmployeeId;
                    delete item.EmployeeName;
                });
                setExternalUsersArray(json);
            } else {
                setExternalUsersArray([]);
            }
        } catch (error) {
            console.error("Error fetching external users:", error);
            setExternalUsersArray([]);
        }
    }


    const getEmployeesAsync = async () => {
        const response = await fetchAPI("api/V2/Approvals/Employees", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json1 = await response.json();
        const json = json1.Data;
        json.map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.FullName;
            delete item.AccountEmployeeId;
            delete item.FullName;
        });

        //const defaultOption = { value: "0", label: "Select" };
        //const arrayWithDefault = [defaultOption, ...json];

        setEmployeesArray(json);
    }

    const getSequenceAsync = async () => {

        let Sequence = [
            { value: '1', label: '1st' },
            { value: '2', label: '2nd' },
            { value: '3', label: '3rd' },
            { value: '4', label: '4th' },
            { value: '5', label: '5th' }
        ]

        setSequenceArray(Sequence);
        const newSelectedOptions: any = [...selectedSequenceOptionDropDown];
        Sequence.map((item: any, index: number) => {
            newSelectedOptions[index] = { value: '1', label: '1st' };
            setSelectedSequenceOptionDropDown(newSelectedOptions);
        })


    }

    useEffect(() => {
        getSystemApproverTypesAsync();
        getExternalUsersAsync();
        getEmployeesAsync();
        getSequenceAsync();
        setIsCanvasLoader(false);

    }, [])

    const handleSystemApproverTypeChange = (selectedOption: any, index: any) => {

        const newSelectedOptions: any = [...selectedSystemApproverTypeOptionDropDown];
        newSelectedOptions[index] = selectedOption;
        setSelectedSystemApproverTypeOptionDropDown(newSelectedOptions);

        const { value, label } = selectedOption;
        if (value !== 4) {
            const newSelectedOptions: any = [...selectedExternalUserOptionDropDown];
            newSelectedOptions[index] = { value: '-1', label: 'Select an option' };
            setSelectedExternalUserOptionDropDown(newSelectedOptions);
        }
        if (value !== 3) {
            const newSelectedOptions: any = [...selectedEmployeeOptionDropDown];
            newSelectedOptions[index] = { value: '-1', label: 'Select an option' };
            setSelectedEmployeeOptionDropDown(newSelectedOptions);
        }
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'SystemApproverTypeId': value, 'AccountExternalUserId': (value !== 4 ? 0 : formik.values.detail[index].AccountExternalUserId), 'AccountEmployeeId': (value !== 3 ? 0 : formik.values.detail[index].AccountEmployeeId) };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));

    };

    const handleExternalUserChange = (selectedOption: any, index: any) => {

        const newSelectedOptions: any = [...selectedExternalUserOptionDropDown];
        newSelectedOptions[index] = selectedOption;
        setSelectedExternalUserOptionDropDown(newSelectedOptions);

        const { value, label } = selectedOption;
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'AccountExternalUserId': value };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));

    };

    const handleEmployeeChange = (selectedOption: any, index: any) => {

        const newSelectedOptions: any = [...selectedEmployeeOptionDropDown];
        newSelectedOptions[index] = selectedOption;
        setSelectedEmployeeOptionDropDown(newSelectedOptions);

        const { value, label } = selectedOption;
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'AccountEmployeeId': value };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));

    };

    const handleSequenceChange = (selectedOption: any, index: any) => {

        const newSelectedOptions: any = [...selectedSequenceOptionDropDown];
        newSelectedOptions[index] = selectedOption;
        setSelectedSequenceOptionDropDown(newSelectedOptions);

        const { value, label } = selectedOption;
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'ApprovalPathSequence': value };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));

    };

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(accountApprovalInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            AccountApprovalTypeId = stateItem.AccountApprovalTypeId;
            setCurrentFieldsData(stateItem);
            //stateItem.IsDisabled = stateItem.IsDisabled  === 'No' ? false : true;

            if (stateItem.detail !== undefined) {
                // stateItem.detail = stateItem.detail.map((item: any) => {                    
                //     const newItem = { ...item };
                //     return newItem;
                //   });

                let newSelectedOptionsExternalUser: any = [...selectedExternalUserOptionDropDown];
                stateItem.detail.map((pitem: any, index: any) => {
                    const nselectedoption = externalUsersArray.find((externalUser: any) => externalUser.value == pitem.AccountExternalUserId);
                    if (nselectedoption !== undefined) {
                        newSelectedOptionsExternalUser[index] = nselectedoption
                        setSelectedExternalUserOptionDropDown(newSelectedOptionsExternalUser);
                    }
                    else {
                        newSelectedOptionsExternalUser[index] = { value: "-1", label: "Select an option" };
                        setSelectedExternalUserOptionDropDown(newSelectedOptionsExternalUser);
                    }
                });



                let newSelectedOptionsSystemApproverTypes: any = [...selectedSystemApproverTypeOptionDropDown];
                stateItem.detail.map((pitem: any, index: any) => {
                    const nselectedoptionSystemApproverTypes = systemApproverTypesArray.find((SystemApproverType: any) => parseInt(SystemApproverType.value) === pitem.SystemApproverTypeId);
                    if (nselectedoptionSystemApproverTypes !== undefined) {
                        newSelectedOptionsSystemApproverTypes[index] = nselectedoptionSystemApproverTypes
                        setSelectedSystemApproverTypeOptionDropDown(newSelectedOptionsSystemApproverTypes);
                    }
                    else {

                        newSelectedOptionsSystemApproverTypes[index] = { value: "-1", label: "Select an option" };
                        setSelectedSystemApproverTypeOptionDropDown(newSelectedOptionsSystemApproverTypes);
                    }
                });


                let newSelectedOptionsEmployees: any = [...selectedEmployeeOptionDropDown];
                stateItem.detail.map((pitem: any, index: any) => {
                    const nselectedoptionEmployee = employeesArray.find((employee: any) => parseInt(employee.value) === pitem.AccountEmployeeId);
                    if (nselectedoptionEmployee !== undefined) {
                        newSelectedOptionsEmployees[index] = nselectedoptionEmployee
                        setSelectedEmployeeOptionDropDown(newSelectedOptionsEmployees);
                    }
                    else {

                        newSelectedOptionsEmployees[index] = { value: "-1", label: "Select an option" };
                        setSelectedEmployeeOptionDropDown(newSelectedOptionsEmployees);
                    }
                });

                let newSelectedSequenceOptionDropDown: any = [...selectedSequenceOptionDropDown];
                stateItem.detail.map((pitem: any, index: any) => {
                    const nselectedoptionSequence = sequenceArray.find((sequence: any) => parseInt(sequence.value) === pitem.ApprovalPathSequence);
                    if (nselectedoptionSequence !== undefined) {
                        newSelectedSequenceOptionDropDown[index] = nselectedoptionSequence
                        setSelectedSequenceOptionDropDown(newSelectedSequenceOptionDropDown);
                    }
                    else {

                        newSelectedSequenceOptionDropDown[index] = { value: "-1", label: "Select" };
                        setSelectedSequenceOptionDropDown(newSelectedSequenceOptionDropDown);
                    }
                });

            }
        }
        else {

            setCurrentFieldsData(accountApprovalInitialsForAdd);
        }
       if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } 
    }, [selectedRecord])

//   const handleSubmit = (e: any) => {

        
//         let counter = 1;
//         for (const row of formik.values.detail) {
//             counter++;
//             let isApprovalInsert = true;
//             const SystemApproverTypeId = row.SystemApproverTypeId; // Assuming row has a property for the selected value
//             const AccountExternalUserId = row.AccountExternalUserId; // Similarly for external user ID
//             const AccountEmployeeId = row.AccountEmployeeId; // Similarly for employee ID

//             if (SystemApproverTypeId === 0) {
//                 if(formik.values.detail.length === counter){
//                     alert('Please select employee.');
//                 }
                
//                 isApprovalInsert = false;
//             } else if (SystemApproverTypeId === 3 && AccountEmployeeId === 0) {
//                 if(formik.values.detail.length === counter){
//                 alert('Please select employee.');
//                 }
//                 isApprovalInsert = false;
//             }
//             else if (SystemApproverTypeId === 4 && AccountExternalUserId === 0 ) {
//                 if(formik.values.detail.length === counter){
//                 alert('Please select employee.');
//                 }
//                 isApprovalInsert = false;
//             }
//             else if (isApprovalInsert) {
                
//                 if (formik.values.AccountApprovalTypeId !== 0) {
//                     dispatch(updateAccountApprovalTypeAsync(formik.values))
//                         .unwrap()
//                         .then((originalPromiseResult) => {
//                             originalPromiseResult.StatusCode === "200" ?
//                                 ShowToast("Account Approval Updated Successfully", 'Success', "success", "toast-top-right") :
//                                 ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
        
//                             //  modelRef.current.click();
//                         })
//                         .catch((rejectedValueOrSerializedError) => {
//                             ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
        
//                         })
//                 }
//                 else {
//                     dispatch(addAccountApprovalTypeAsync(formik.values))
//                         .unwrap()
//                         .then((originalPromiseResult) => {
//                             originalPromiseResult.StatusCode === "201" ?
//                                 ShowToast("Time Off Policy Added Successfully", 'Success', "success", "toast-top-right") :
//                                 ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
        
        
//                         })
//                         .catch((rejectedValueOrSerializedError) => {
//                             ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
        
//                         })
//                 }
//                 if (closeButtonRef.current) {
//                     closeButtonRef.current.click();
//                 }
//                 return; // Exit the loop
//             }
//         }

       
//     }

  const handleSubmit = (e: any) => {
        let isAnyRowValid = false;

        for (let i = 0; i < formik.values.detail.length; i++) {
            const row = formik.values.detail[i];
            const SystemApproverTypeId = row.SystemApproverTypeId;
            const AccountExternalUserId = row.AccountExternalUserId;
            const AccountEmployeeId = row.AccountEmployeeId;
            if (!SystemApproverTypeId || SystemApproverTypeId === 0) {
                continue;
            }
            if (SystemApproverTypeId === 3) {
                if (!AccountEmployeeId || AccountEmployeeId === 0) {
                    alert(`Please select Employee.`);
                    return;
                }
            }
            if (SystemApproverTypeId === 4) {
                if (!AccountExternalUserId || AccountExternalUserId === 0) {
                    alert(`Please select External User.`);
                    return;
                }
            }
            isAnyRowValid = true;
        }

        if (!isAnyRowValid) {
            alert("Please fill at least one valid Approver Type.");
            return;
        }
        if (isAnyRowValid) {
            if (formik.values.AccountApprovalTypeId !== 0) {
                dispatch(updateAccountApprovalTypeAsync(formik.values))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        originalPromiseResult.StatusCode === "200" ?
                            ShowToast("Account Approval Updated Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

                        //  modelRef.current.click();
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");

                    })
            }
            else {
                dispatch(addAccountApprovalTypeAsync(formik.values))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        originalPromiseResult.StatusCode === "201" ?
                            ShowToast("Account Approval Added Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");


                    })
                    .catch((rejectedValueOrSerializedError) => {
                        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");

                    })
            }
            if (closeButtonRef.current) {
                closeButtonRef.current.click();
            }
            return;
        }

    };

 
    const handleSelectAllChange = (e: any) => {
        const { values } = formik;
        const newData = values.detail.map((item: any) => ({
            ...item,
            isSelected: e.target.checked === true ? 1 : 0,
        }));

        setCurrentFieldsData({
            ...values,
            detail: newData,
        });

    };


    const handleCheckboxChange = (e: any, AccountApprovalPathId: any) => {
        const { values } = formik;
        const newData = values.detail.map((item: any, index: any) => {
            if (item.AccountApprovalPathId === AccountApprovalPathId) {
                return { ...values.detail[index], 'isSelected': e.target.checked === true ? 1 : 0 };
            }
            return item;
        });

        setCurrentFieldsData({
            ...values,
            detail: newData,
        });


    };
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    const onDeleteSelectedClick = () => {       

        const hasValidSystemApproverType = formik.values.detail
            .filter((item: any) => item.isSelected === 1)
            .some((item: any) =>
                item.SystemApproverTypeId !== 0 &&
                item.SystemApproverTypeId !== null &&
                item.SystemApproverTypeId !== undefined
            );
        if (!hasValidSystemApproverType) {
            ShowToast("No deletable records found", 'Warning', "warning", "toast-top-right");
            return; 
        }

        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", 'Yes delete it!', 'custom-swal-container')
            .then((result) => {
                if (result) {
                    AccountApprovalTypeId = formik.values.AccountApprovalTypeId
                    dispatch(DeleteSelectedAccountApprovalPathAsync(formik.values.detail))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Account approval path(s) deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                            if (AccountApprovalTypeId !== 0 && AccountApprovalTypeId !== undefined && AccountApprovalTypeId !== null) {
                                dispatch(getAccountApprovalByAccountApprovalTypeIdAsync(AccountApprovalTypeId))
                                    .unwrap()
                                    .then((originalPromiseResult) => {
                                    })
                                    .catch((rejectedValueOrSerializedError) => {

                                    })
                            }
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");

                        })
                }
            })
            .catch((error) => {

            });
        
        }
    return (
        <>
            {/* <form > */}
            <div className='card-body card-pad'>
                {isCanvasLoader ? <CanvasLoader /> : <>
                    {isLoading ?
                        <div className="col-md-12">
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-md ms-2'></span>
                            </span>
                        </div>
                        : <>
                            <div className='row'>
                                <div className="col-md-12 mb-2">
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {/* {t('Approval Type Name')} */}
                                        {getValueFromResource('Approval Type Name',dispatch, t)}
                                        </label>
                                    <input type="text"
                                        className="form-control fs-7 fw-normal"
                                        id='ApprovalTypeName'
                                        value={formik.values.ApprovalTypeName}
                                        onChange={formik.handleChange('ApprovalTypeName')}
                                        ref={defaultFocusRef}
                                        // onBlur={() => formik.setFieldTouched('ApprovalTypeName')}
                                    />
                                    <div >
                                        {formik.touched.ApprovalTypeName && formik.errors.ApprovalTypeName &&
                                            <p className='errorMsg'>{formik.errors.ApprovalTypeName as string}</p>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-12 mb-2" style={{ marginTop: '5px' }}>
                                    <div className="mb-3 mt-2" >
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t('Is Time Off Approval')} */}
                                            {getValueFromResource('Is Time Off Approval',dispatch, t)}
                                            </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                            <input type="checkbox"
                                                className="form-check-input h-15px w-30px"
                                                checked={formik.values.IsTimeOffApprovalTypes}
                                                id="IsTimeOffApprovalTypes"
                                                onChange={formik.handleChange('IsTimeOffApprovalTypes')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr />

                                <div className='card-title'>
                                    <div className='d-flex justify-content-center flex-column me-3'>
                                        <a className='fs-4 fw-bolder text-gray-900  me-1 mb-2 lh-1 d-flex align-items-center gap-1'>
                                            {/* {t('Approval Path')} */}
                                            {getValueFromResource('Approval Path', dispatch, t)}
                                            <div
                                                style={{ marginBottom: "2px" }}
                                                data-tooltip-id="tooltip-approvalForm"
                                                data-tooltip-content={getValueFromResource("Define the approval workflow by adding one or more approval steps. Configure approvers, approval type, approval sequence, and whether approvals occur sequentially or in parallel. Approvers with the same sequence number approve in parallel, while higher sequence numbers are processed after earlier approvals are completed.", dispatch, t)}
                                            >
                                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                            </div>
                                        </a>

                                    </div>
                                </div>
                                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" style={{ overflow: 'auto' }}>
                                    <thead>
                                        <tr className="thHeading align-middle">
                                            {IsDelete && (
                                                formik.values.AccountApprovalTypeId !== 0 ? (
                                                    <th className='w-25px'>
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                            <input
                                                                className='form-check-input'
                                                                type='checkbox'
                                                                checked={formik.values.detail.every((item: any) => item.isSelected === 0) ? false :
                                                                    (formik.values.detail.every((item: any) => item.isSelected === 1 ? true : false))}
                                                                onChange={handleSelectAllChange}
                                                            />
                                                        </div>
                                                    </th>
                                                ) : null
                                            )}
                                            <th className='w-175px'>
                                                {/* {t('Approver Type')} */}
                                                {getValueFromResource('Approver Type',dispatch, t)}
                                                </th>
                                            <th className='w-175px'>
                                                {/* {t('External User')} */}
                                                {getValueFromResource('External User',dispatch, t)}
                                            </th>
                                            <th className='w-175px'>
                                                {/* {t('Employee')} */}
                                                {getValueFromResource('Employee',dispatch, t)}
                                                </th>
                                            <th className='w-20px'>
                                                {/* {t('Sequence')} */}
                                                {getValueFromResource('Sequence',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {formik.values.detail.map((accountApprovalPathDetails: any, index: any) =>

                                            <tr key={index}>
                                                {IsDelete && (formik.values.AccountApprovalTypeId !== 0) ? (
                                                    <td>
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input widget-9-check "
                                                                checked={accountApprovalPathDetails.isSelected === 0 ? false : true}
                                                                onChange={e => handleCheckboxChange(e, accountApprovalPathDetails.AccountApprovalPathId)}
                                                            />
                                                        </div>
                                                    </td>
                                                ) : null}
                                                <td>
                                                    <Select
                                                        key={index}
                                                        value={selectedSystemApproverTypeOptionDropDown[index]}
                                                        onChange={(selectedOption) => handleSystemApproverTypeChange(selectedOption, index)}
                                                        options={systemApproverTypesArray}
                                                        placeholder="Select an option"
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        isSearchable={true}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        id="SystemApproverTypeId"
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        key={index}
                                                        value={selectedExternalUserOptionDropDown[index]}
                                                        onChange={(selectedOption) => handleExternalUserChange(selectedOption, index)}
                                                        options={externalUsersArray}
                                                        placeholder="Select an option"
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        isSearchable={true}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        id="AccountExternalUserId"
                                                        isDisabled={accountApprovalPathDetails.SystemApproverTypeId === 4 ? false : true}
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        key={index}
                                                        value={selectedEmployeeOptionDropDown[index]}
                                                        onChange={(selectedOption) => handleEmployeeChange(selectedOption, index)}
                                                        options={employeesArray}
                                                        placeholder="Select an option"
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        isSearchable={true}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        id="AccountEmployeeId"
                                                        isDisabled={accountApprovalPathDetails.SystemApproverTypeId === 3 ? false : true}
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        key={index}
                                                        value={selectedSequenceOptionDropDown[index]}
                                                        onChange={(selectedOption) => handleSequenceChange(selectedOption, index)}
                                                        options={sequenceArray}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        isSearchable={true}
                                                        className="basic-single"
                                                        id="ApprovalPathSequence"
                                                    />
                                                </td>

                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                        </>
                    }
                </>
                }
                {Object.keys(formik.errors).length > 0 && (
                    <div className="mt-3 alert alert-danger">
                        <strong>
                            {/* {t('Error Summary')}: */}
                            {getValueFromResource('Error Summary',dispatch, t)}:

                            </strong>
                        <ul>
                            {Object.keys(formik.errors).map((fieldName, index) => (
                                <li key={index}>{formik.errors[fieldName] as string}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    {IsDelete &&
                        <>
                            <div className="fw-bold me-5" style={{ marginRight: '2px', display: formik.values.detail.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                <span className="me-2" data-kt-user-table-select="selected_count">{formik.values.detail.filter((item: any) => item.isSelected === 1).length}</span>
                                 {/* {t('Selected')} */}
                                 {getValueFromResource('Selected',dispatch, t)}
                            </div>
                            <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                style={{ marginRight: '2px', display: formik.values.detail.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                            >
                                {/* {t('Delete Selected')} */}
                                {getValueFromResource('Delete Selected',dispatch, t)}
                            </button>
                        </>}
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                        id="kt_OffCanvas"
                        style={{ marginRight: '2px', display: formik.values.detail.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                        onClick={handleCloseOnClickEvent}
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel',dispatch, t)}
                    </button>

                    <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => formik.handleSubmit()} disabled={!formik.isValid}
                        data-kt-element='send'
                        style={{ marginRight: '2px', display: formik.values.detail.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                    >
                        {/* {t('Save')} */}
                        {getValueFromResource('Save',dispatch, t)}
                    </button>
                    {/* </div> */}
                </div>
            </div>
            {/* <div className='card-footer pt-4 '>
                                <div className='d-flex flex-stack float-end'>
                                    <div className='d-flex align-items-center me-2'>
                                        <div className="fw-bold me-5" style={{ marginRight: '2px', display: formik.values.detail.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                            <span className="me-2" data-kt-user-table-select="selected_count">{formik.values.detail.filter((item: any) => item.isSelected === 1).length}</span> Selected
                                        </div>
                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                            style={{ marginRight: '2px', display: formik.values.detail.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                        >
                                            Delete Selected
                                        </button>
                                        <button
                                            ref={closeButtonRef}
                                            type="button"
                                            className="btn btn-light btn-sm me-2"
                                         
                                            id="kt_OffCanvas"
                                            onClick={handleCloseOnClickEvent}
                                            style={{ marginRight: '2px', display: formik.values.detail.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                                        >
                                            {t('Cancel')}
                                        </button>

                                        <button  type="button" className="btn btn-light-primary btn-sm" 
                                         style={{ marginRight: '2px', display: formik.values.detail.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                                        onClick={() => formik.handleSubmit()} disabled={!formik.isValid}>
                                           
                                            {(formik.values.AccountApprovalTypeId !== 0 ) ?  t('Update') :  t('Add')}
                                          
                                        </button>
                                    </div>
                                </div>
                            </div> */}


            {/* </form> */}
            {/* </Fragment>
                )}
            </Formik> */}
            <ReactTooltip
                id="tooltip-approvalForm"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

